import { useLayoutPrefs } from "@/contexts/LayoutPrefsContext";

export function PageHeader({ overline, title, description, actions, testid }) {
    return (
        <div className="flex items-start justify-between gap-6 border-b border-border pb-6 mb-8" data-testid={testid}>
            <div>
                {overline && <div className="label-overline mb-3">{overline}</div>}
                <h1 className="text-3xl md:text-4xl font-bold tracking-tight">{title}</h1>
                {description && (
                    <p className="text-sm text-muted-foreground mt-2 max-w-xl">{description}</p>
                )}
            </div>
            {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
    );
}

export function PageContainer({ children, className = "" }) {
    const { wide } = useLayoutPrefs();
    return <div className={`px-8 py-10 mx-auto ${wide ? "max-w-none w-full" : "max-w-[1400px]"} ${className}`} data-wide={wide ? "1" : "0"}>{children}</div>;
}

export function EmptyState({ icon: Icon, title, description, action, testid }) {
    return (
        <div className="border border-dashed border-border rounded-sm p-12 flex flex-col items-center text-center" data-testid={testid}>
            {Icon && <Icon size={32} weight="duotone" className="mb-4 text-muted-foreground" />}
            <div className="text-base font-medium">{title}</div>
            {description && <div className="text-sm text-muted-foreground mt-1 max-w-md">{description}</div>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
